// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__HlLIC","toggleWrap":"styles_toggleWrap__25d-Y","content":"styles_content__2T5ZZ","selectAreaCode":"styles_selectAreaCode__3cOD2"};